export function buildArticleNumbers(
  mode: 'single' | 'range',
  itemCode: string,
  name: string,
  start: number,
  end: number,
  padding: number,
  position: 'before' | 'after',
) {
  const code = itemCode.trim();
  if (!code) return [];
  if (mode === 'single') return [{ itemCode: code, name: name.trim() }];
  if (
    !Number.isSafeInteger(start) ||
    !Number.isSafeInteger(end) ||
    start < 0 ||
    end < start ||
    end - start > 99 ||
    !Number.isInteger(padding) ||
    padding < 0 ||
    padding > 100
  )
    return [];
  return Array.from({ length: end - start + 1 }, (_, index) => {
    const number = String(start + index).padStart(padding, '0');
    return {
      itemCode: position === 'before' ? `${number}${code}` : `${code}${number}`,
      name: name.trim(),
    };
  });
}

export function filterArticleTargets<T extends { itemCode: string }>(
  targets: T[],
  ignoreClashes: boolean,
  isClashing: (itemCode: string) => boolean,
): T[] {
  return ignoreClashes
    ? targets.filter((target) => !isClashing(target.itemCode))
    : targets;
}

export function getArticleNumberLimits(
  mode: 'single' | 'range',
  start: number,
  end: number,
  padding: number,
  templateMaximum?: number | null,
) {
  const maximumLength =
    templateMaximum && templateMaximum > 0
      ? Math.min(100, templateMaximum)
      : 100;
  const reservedDigits =
    mode === 'range'
      ? Math.max(padding, String(start).length, String(end).length)
      : 0;
  return {
    maximumLength,
    reservedDigits,
    inputMaxLength: Math.max(0, maximumLength - reservedDigits),
  };
}
